import './progressBar.scss';

import clamp from 'lodash/clamp';
import { ReactNode } from 'react';

import { locator } from '../../testing/e2e-locator/locator';
import { ProgressBarProps } from './types/ProgressBarProps';

export const ProgressBar = ({
  'aria-label': ariaLabel,
  testId = locator.components.progressBar.root,
  value,
}: ProgressBarProps): ReactNode => {
  const percent = clamp(value, 0, 100);

  return (
    <div
      aria-label={ariaLabel}
      aria-valuemax={100}
      aria-valuemin={0}
      aria-valuenow={Math.round(percent)}
      className="progress-bar"
      data-testid={testId}
      role="progressbar"
    >
      <div
        className="progress-bar-fill"
        style={{ transform: `translateX(${percent - 100}%)` }}
      />
    </div>
  );
};
